import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores'
import axios from "axios"
import i18n from './i18n';

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

new Vue({
    router,
    store,
    axios,
    i18n,
    render: h => h(App)
}).$mount('#app')